<!--<router-outlet></router-outlet>-->
<div class="content" [@fadeAnimation]="getRouterOutletState(o)">
    <router-outlet #o="outlet"></router-outlet>
</div>
